module.exports = __webpack_public_path__ + "img/team-member-3.5ab1e834.jpg";